



















































import Vue from 'vue'
import './TwitterPollDetails.scss'
import { TweetPollAsset } from '@/types/assets'

export default Vue.extend({
  name: 'TwitterPollDetails',
  props: {
    asset: {
      type: Object as () => TweetPollAsset
    }
  },
  watch: {
    asset (newValue) {
      console.log('Received asset', newValue);

    }
  },
  data: function (): any {
    return {
      isSelecting: false,
      selectionPreview: '', // shown while selecting
      maxChars: 150,
      editing: false,
      maxLengthExceeded: false
    }
  },
  computed: {
    answers (): any[] {
      return this.asset.answers ? this.asset.answers : []
    },
    question (): string {
      if (this.asset && this.asset.question) {
        return this.asset.question
      }
      return ''
    },
    summary (): string {
      const warning = (this.asset.up_to_date) ? '' : ' • RESULTS SHOWN WHEN POLL IS FINAL'


      if (this.asset && this.asset.timeleft) {
        return `${this.asset.num_votes} votes • ${this.asset.timeleft}${warning}`
      }
      return ''
    },
    twitterRef (): string {
      return (this.asset.url) ? '@' + this.asset.url.split('/')[3] : ''
    }
  },
  methods: {
    isBiggest (answer): boolean {
      if (this.answers.some(a => a.percent >= answer.percent && a.answer !== answer.answer)) {
        return false
      }

      return true
    },
    barWidth (answer): any {
      return {
        width: `${answer.percent}%`,
      }
    },
    barstyle (answerindex): any {
      const colors = ['#397BCE', '#03AEEF', '#D69D36', '#4D4D4D', '#EEEEEE']
      return {
        'background-color': colors[answerindex],
        width: this.answers[answerindex] ? this.answers[answerindex].percent + '%' : '0%',
        color: 'rgba(0, 0, 0, 0)'
      }
    }
  }
})
